import { render } from "./ProdutoNovo.vue?vue&type=template&id=1ab516f0&scoped=true"
import script from "./ProdutoNovo.vue?vue&type=script&lang=js"
export * from "./ProdutoNovo.vue?vue&type=script&lang=js"

import "./ProdutoNovo.vue?vue&type=style&index=0&id=1ab516f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab516f0"]])

export default __exports__